module.exports = __webpack_public_path__ + "static/media/sexual-behavior.21a703c3.svg";